
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class EmailTemplateVariablesDialog extends Serenity.EntityDialog<EmailTemplateVariablesRow, any> {
        protected getFormKey() { return EmailTemplateVariablesForm.formKey; }
        protected getIdProperty() { return EmailTemplateVariablesRow.idProperty; }
        protected getLocalTextPrefix() { return EmailTemplateVariablesRow.localTextPrefix; }
        protected getNameProperty() { return EmailTemplateVariablesRow.nameProperty; }
        protected getService() { return EmailTemplateVariablesService.baseUrl; }
        protected getDeletePermission() { return EmailTemplateVariablesRow.deletePermission; }
        protected getInsertPermission() { return EmailTemplateVariablesRow.insertPermission; }
        protected getUpdatePermission() { return EmailTemplateVariablesRow.updatePermission; }

        protected form = new EmailTemplateVariablesForm(this.idPrefix);

    }
}